import AVATAR_1 from "../../images/NCXMember-avatar-1.png"
import AVATAR_2 from "../../images/NCXMember-avatar-2.png"
import AVATAR_3 from "../../images/NCXMember-avatar-3.png"
import AVATAR_4 from "../../images/NCXMember-avatar-4.png"
import AVATAR_5 from "../../images/NCXMember-avatar-5.png"
import AVATAR_6 from "../../images/NCXMember-avatar-6.png"

const PaywallFooter = () => {
  const profileImages = [
    AVATAR_6,
    AVATAR_5,
    AVATAR_4,
    AVATAR_3,
    AVATAR_2,
    AVATAR_1,
  ]

  return (
    <div
      className="w-full h-full bg-green-900 py-14 lg:pb-28 px-[10px] md:px-17"
      data-testid="paywall-footer"
    >
      <h3
        className="text-white text-center text-4xl font-display font-medium leading-[124%] tracking-[0.72px]"
        data-testid="paywall-footer-heading"
      >
        Ready to transform your forest managing experience?
      </h3>

      <p
        className="text-white text-center text-xl font-display font-medium leading-[140%] tracking-[0.4px] mt-2"
        data-testid="paywall-footer-text"
      >
        Join thousands of forest owners who are discovering the benefits of
        personalized expert guidance
      </p>

      <div className="flex flex-wrap items-center justify-center gap-9 md:gap-22 mt-14">
        <div className="flex items-center gap-5">
          <div className="flex -space-x-4 mb-4 md:mb-0">
            {profileImages.map((src, index) => (
              <div
                key={index}
                className="w-12 h-12 rounded-full border-2 border-green-900 overflow-hidden"
              >
                <img
                  src={src}
                  alt={`Landowner ${index + 1}`}
                  className="w-full h-full object-cover"
                  data-testid={`paywall-footer-avatar-${index + 1}`}
                />
              </div>
            ))}
          </div>

          <p
            className="text-white text-center font-bold leading-[140%] tracking-[0.32px]"
            data-testid="paywall-footer-join-text"
          >
            Join 1,000+
            <br />
            Landowners
          </p>
        </div>

        <div className="max-w-2xl">
          <button
            className={
              "personal-advisor-paywall footer-become-member bg-white btn2 btn2-outline-primary font-semibold btn2-block px-6 py-3 sm:btn2-inline-block sm:inline-block"
            }
            onClick={() => {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              })
            }}
            data-testid="paywall-footer-join-button"
          >
            Become an NCX Member Today
          </button>
        </div>
      </div>
    </div>
  )
}

export default PaywallFooter
